





































/* tslint:disable */
import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { MswAppTitle } from '@/shared/msw-app-title';
import { ConfirmButton, ConfirmOptions, confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { required } from 'vuelidate/lib/validators';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { DropdownLight } from '@/shared/dropdown-light';
import { InfoState } from '@/core';

const cssPrefix = 'otheroperations';

@Component({
  components: {
    ...UUIFComponent,
    MswAppTitle,
    DropdownLight,
  },
  directives: {
    tooltip,
  },
  validations:{
    deleteRecord: {
      subscriptionEndDate: { required },
      cancelDate: { required },
      comments: { required },
    },
  },
})

export default class OtherOperationsComponent extends SwExtendedVue {
  cssPrefix = cssPrefix;
  username: string = 'ALL';
  application: string = '';
  applicationsList: SelectOption[] = [];

  
  dropdownMenuSelect(e: any) {
    console.log('Travis Scott :: ', this.application);
  }

  showConfirmDialog(message: string) {
    const buttonsTransferConfirm: ConfirmButton[] = [
      { key: 'no', name: 'Cancel' },
      { key: 'yes', name: 'Confirm', isDefault: true },
    ];
    const optionsTransferConfirm: ConfirmOptions = {
      message,
      status: 'high',
      title: 'Warning',
      buttons: buttonsTransferConfirm,
    };
    return confirmService.confirm(optionsTransferConfirm);
  }

  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    // this.$store.commit('displayMessage', message);
    this.$store.commit('enqueueMessage', message);
  }

  clearSiteMapCache() {
    this.showConfirmDialog(`Are you sure you want to clear the sitemap cache for this user?`)
      .then((key: any) => {
        if(key === 'yes') {
          const payload = {
            username : this.username,
            applicationname: this.application,
          };
          this.$store.dispatch('clearSiteMapCache', payload).then((resp) => {
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK') {
              this.showMessage('success', resp.msgDesc);
            } else {
              this.showMessage('failed', resp.msgDesc);
            }
          });
        }
      });
  }

  mounted() {
    this.applicationsList = [
      { id: 'all', label: 'ALL', value: 'all' },
      { id: 'msw', label: 'MSW', value: 'msw' },
      { id: 'snb', label: 'SNB', value: 'snb' },
    ];
    this.application = this.applicationsList[0].id;
  }
}
